import { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Loading from "./components/shared/Loading/Loading";
import ScrollToTop from "./ScrollToTop";
import "./App.scss";
import Aos from "aos";
import "aos/dist/aos.css";
import { IntlProvider } from "react-intl";
import RainEffect from "./components/shared/RainEffect";
import { CartProvider } from "./store/CartContext";
import "./i18n";

const Home = lazy(() => import("./pages/Home/Home"));
const Shop = lazy(() => import("./pages/Shop/Shop"));
const Checkout = lazy(() => import("./pages/Checkout/Checkout"));
const Contact = lazy(() => import("./pages/ContactUs/ContactUs"));
const Wholesale = lazy(() => import("./pages/Wholesale/Wholesale"));
const AboutUs = lazy(() => import("./pages/AboutUs/AboutUs"));


function App() {
  useEffect(() => {
    Aos.init({
      duration: 1250,
      once: true,
    });
  }, []);

  return (
    <Router>
      <CartProvider>
        <Suspense fallback={<Loading />}>
          <IntlProvider>
            <ScrollToTop />
            <RainEffect />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/Shop" element={<Shop />} />
              <Route exact path="/Checkout" element={<Checkout />} />
              <Route exact path="/Contact" element={<Contact />} />
              <Route exact path="/AboutUs" element={<AboutUs />} />
              <Route exact path="/Wholesale" element={<Wholesale />} />

              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </IntlProvider>
        </Suspense>
      </CartProvider>
    </Router>
  );
}

export default App;
